export const BORDER_RADIUS = "5px";